var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.534 491.534",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M434.308,403.615c0.465-0.465,0.893-0.944,1.301-1.432c0.022-0.026,0.042-0.054,0.064-0.08 c3.495-4.212,4.913-9.188,4.634-14.003V102.414c0-11.311-9.169-20.48-20.48-20.48h-61.44v-61.44 c0-13.779-13.333-23.627-26.503-19.574L65.644,82.84c-8.593,2.644-14.457,10.584-14.457,19.574v286.72v40.96 c0,33.941,27.499,61.44,61.44,61.44h307.2c18.246,0,27.383-22.06,14.482-34.962C415.006,437.271,415.006,422.917,434.308,403.615 z M399.346,122.894v245.76h-191.48l136.063-41.866c8.593-2.644,14.457-10.583,14.457-19.574v-184.32H399.346z M317.426,48.223 v54.191v189.674l-225.28,69.317V117.54L317.426,48.223z M382.347,450.574h-269.72c-11.32,0-20.48-9.16-20.48-20.48 c0-11.32,9.16-20.48,20.48-20.48h269.72C377.713,423.188,377.713,437,382.347,450.574z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.733,244.986l143.36-40.96c8.792-2.512,14.854-10.548,14.854-19.692v-81.92c0-13.607-13.023-23.43-26.106-19.692 l-143.36,40.96c-8.792,2.512-14.854,10.548-14.854,19.692v81.92C112.626,238.9,125.65,248.724,138.733,244.986z M153.586,158.822 l102.4-29.257v39.321l-102.4,29.257V158.822z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookWhite);
export default __webpack_public_path__ + "static/media/book-white.8030e8f508fa2f2502cad286816698ec.svg";
export { ForwardRef as ReactComponent };